import angular from 'angular';
import moment from 'moment';
import { dynamicSort, dynamicSortMultiple } from '@/shared/utils/dynamicSort';
import dateFormatService from '../../../shared/services/DateFormatService';

angular
  .module('cloudX')
  .controller('EmpNewCtrl', [
    'resourceFactorySvc',
    '$state',
    'flySvc',
    'licensingSvc',
    'dataCache',
    '$translate',
    'appSettings',
    '$stateParams',
    '$q',
    'enumCacheSvc',
    '$filter',
    '$http',
    'appUrls',
    empNewCtrl,
  ]);

function empNewCtrl(
  resourceFactorySvc,
  $state,
  flySvc,
  licensingSvc,
  dataCache,
  $translate,
  appSettings,
  $stateParams,
  $q,
  enumCacheSvc,
  $filter,
  $http,
  appUrls,
) {
  var vm = this;
  vm.isTrial = false;
  vm.appSettings = appSettings;
  vm.userRoles = [];
  vm.employeeProfiles = [];
  vm.showValidation = false;
  vm.isTemporary = $stateParams.temporary || false;
  vm.emp = {
    lastName: '',
    firstName: '',
    employeePhone: '',
    employeeAddress: {
      country: appSettings.defaultCountry,
    },
    employeeEmail: '',
    employeeStartDate: new Date(),
    employeeEndDate: '0001-01-01T00:00:00Z',
    employeeInitials: '',

    userID: null,
    userEmail: null,
    userRole: null,
    userEnabled: true,
    userLanguage: 'nl',
    userTravelFromHome: false,
    userTravelOneWay: false,
    excludedFromSso: false,
    license: null,
    companyId: dataCache.getDefaultCompany()?.id,
  };
  vm.usesSso = false;
  vm.licenses = [];
  vm.companies = dataCache.getCompanies();
  var resource = resourceFactorySvc.get('employee');
  var employeeProfileResource = resourceFactorySvc.get('employeeProfile');

  licensingSvc.reloadLicenseInformation().then(function(result) {
    if (result) {
      vm.licenseInformation = result;
      if (vm.isTemporary) {
        const newLicense = {
          beginDate: moment()
            .utc()
            .startOf('day')
            .toDate(),
          endDate: moment()
            .utc()
            .startOf('day')
            .add(1, 'months')
            .toDate(),
          name: $translate.instant('New temporary license'),
          isTemporary: true,
        };
        vm.licenses = [
          newLicense,
          ...(result.temporaryLicenses || [])
            .filter(x => !x.userId)
            .map(x => ({
              ...x,
              name: `${dateFormatService.formatDate(x.beginDate)} - ${dateFormatService.formatDate(
                x.endDate,
              )}`,
            }))
            .sort(dynamicSortMultiple('beginDate', 'endDate')),
        ];

        if (vm.licenses.length === 1) {
          vm.emp.license = newLicense;
          vm.licenseMonths = moment
            .utc(vm.emp.license.endDate)
            .diff(moment.utc(vm.emp.license.beginDate), 'months', true);
        } else if (vm.licenses.length > 1) {
          vm.emp.license = vm.licenses[1];
          vm.licenseChanged();
        }
      }
    }
  });

  employeeProfileResource.query().$promise.then(
    result => {
      vm.employeeProfiles = result;
      var defaultEmployeeProfile = vm.employeeProfiles.find(x => x.isDefault);

      if (defaultEmployeeProfile) {
        defaultEmployeeProfile.name = `${defaultEmployeeProfile.name} 🟊`;
        vm.emp.employeeProfileId = defaultEmployeeProfile.id;
        vm.emp.employeeProfile = defaultEmployeeProfile;
      }
    },
    error => {
      flySvc.error(error.data.code);
    },
  );

  dataCache.ready().then(function() {
    vm.emp.employeeAddress.country = appSettings.defaultCountry;
    vm.usesSso = (dataCache.getArray('ssoProvider') || 0) > 0;
  });

  vm.submitNewEmp = function() {
    if (vm.newRelForm.$invalid) return;

    if (
      !vm.isTemporary &&
      vm.licenseInformation.availableLicenses === 0 &&
      !vm.emp.agreedNewLicense &&
      !vm.licenseInformation.isTrial &&
      vm.licenseInformation.billPerLicense
    )
      return;
    if (
      vm.isTemporary &&
      !vm.emp.license.id &&
      !vm.emp.agreedNewLicense &&
      vm.licenseInformation.billPerLicense
    )
      return;
    vm.emp.userRoles = vm.emp.userRole !== null ? [vm.emp.userRole] : [];
    vm.emp.employeeProfileId = vm.emp.employeeProfile ? vm.emp.employeeProfile.id : null;

    vm.saving = true;
    // save new employee
    return resource.create(
      vm.emp,
      function(success) {
        vm.saving = false;
        flySvc.success('msgNewEmpCreated');
        licensingSvc.reloadLicenseInformation();
        dataCache.getArray('user').push({
          employeeID: success.employeeID,
          userID: success.userID,
          firstName: success.firstName,
          lastName: success.lastName,
          isActive: success.isActive,
          languageCode: success.languageCode,
          email: success.userEmail,
        });
        $state.go('employees.overview');
      },
      function(error) {
        vm.saving = false;
        flySvc.error(error);
      },
    ).$promise;
  };

  vm.cancel = function() {
    $state.go('employees.overview');
  };

  vm.licBeginDateOptions = {
    minDate: moment()
      .utc()
      .startOf('day')
      .toDate(),
  };
  vm.licEndDateOptions = {};
  vm.licenseChanged = function() {
    vm.datesChanged();
    vm.emp.agreedNewLicense = !!vm.emp.license && !!vm.emp.license.id;
  };

  vm.datesChanged = function() {
    if (!vm.emp.license || vm.emp.license.id) return;
    if (vm.emp.license.beginDate) {
      vm.licEndDateOptions.minDate = moment
        .utc(vm.emp.license.beginDate)
        .add(1, 'months')
        .toDate();
      vm.licEndDateOptions.maxDate = moment
        .utc(vm.emp.license.beginDate)
        .add(6, 'months')
        .toDate();
    }
    if (vm.emp.license.endDate) {
      if (vm.emp.license.endDate > vm.licEndDateOptions.maxDate) {
        vm.emp.license.endDate = vm.licEndDateOptions.maxDate;
      }
      if (vm.emp.license.endDate < vm.licEndDateOptions.minDate) {
        vm.emp.license.endDate = vm.licEndDateOptions.minDate;
      }
      vm.licenseMonths = moment
        .utc(vm.emp.license.endDate)
        .diff(moment.utc(vm.emp.license.beginDate), 'months', true);
    }
  };
  $q.all([$http.get(`${appUrls.api}/api/TenantRole`), enumCacheSvc.get('role')]).then(
    ([{ data: tenantRoles }, defaultRoles]) => {
      vm.userRoles = [
        ...defaultRoles
          .map(x => ({
            role: x.key,
            label: $filter('translateList')(x.key, 'role', x.value),
            customRoleId: null,
            customRoleName: null,
            group: $translate.instant('DefaultRoles'),
          }))
          .sort(dynamicSort('role')),
        ...(tenantRoles || [])
          .map(x => ({
            role: 99,
            label: x.name,
            customRoleId: x.id,
            customRoleName: x.name,
            group: $translate.instant('CustomRoles'),
          }))
          .sort(dynamicSort('label')),
      ];
    },
  );
}
